import { helpers, email } from 'vuelidate/lib/validators'
import { http } from 'utils'

export default function(value) {
  if (!helpers.req(value) || !email(value)) return true

  return http.get('/check_email', {
      params: { email: value },
    })
    .then(response => !response.data.exists)
}
